module.exports = __webpack_public_path__ + "img/aboutUsImg07.15316453.png";